import { BusinessProfile } from '@iot-platform/models/common';
import { createSelector } from '@ngrx/store';
import { get } from 'lodash';
import { authFeatures } from '../reducers/auth-features';
import { adapter } from '../reducers/auth-business-profiles-api.reducer';
import { selectCurrentUser } from './auth-api.selectors';

export const { selectAuthBusinessProfilesApi: selectAuthBusinessProfilesApiState } = authFeatures;

export const {
  selectIds: getBusinessProfilesIds,
  selectEntities: getBusinessProfilesEntities,
  selectAll: getAllBusinessProfiles,
  selectTotal: getTotalBusinessProfiles
} = adapter.getSelectors(selectAuthBusinessProfilesApiState);

export const selectSelectedBusinessProfileId = createSelector(selectAuthBusinessProfilesApiState, (state) => state.selectedBusinessProfileId);

export const selectSelectedBusinessProfile = createSelector(
  getBusinessProfilesEntities,
  selectSelectedBusinessProfileId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const selectCurrentBusinessProfile = createSelector(
  selectCurrentUser,
  selectSelectedBusinessProfileId,
  (user, id) => get(user, 'businessProfiles', []).find((_bp: BusinessProfile) => _bp.id === id) ?? { id }
);
